import { Frame, Img } from "./DeckShell";
import { TEAM } from "./TeamAndPartners";

/* «Who is behind it» — credibility before the pitch: the team, large; the delivery coalition, large; honest statuses.
   Shared by the Master (Presenting Partner) deck and the Vision («The Next Shift») deck. */
export const WHO_ROLE = {
  "Martin Kviteberg": "CEO · programme, partners & delivery",
  "Sarah Sleeman": "Partner · operations & experience",
  "Sigrid Kviteberg": "Partner · technology · Global InTech AS",
  "Vernand Morency": "International relations & partnerships · former NFL (Green Bay Packers, Houston Texans), real-estate developer, Washington DC",
};
export const WHO_DELIVERY = [
  ["Replit", "/logos/partners/replit.svg", "replit", "Build Partner", "Live build on the main stage and the Build Lab — a real business problem turned into working software", "Agreed in principle", "on"],
  ["Unite Event", "/logos/unite.svg", "unite", "Production & experience partner", "Project leadership, run-of-show, logistics and the participant journey", "Proposed", ""],
  ["Cure", "/logos/cure.svg", "cure", "Brand, media & distribution partner", "Identity, launch system, PR, content and paid distribution", "Proposed", ""],
  ["Grieghallen", "/logos/grieghallen.svg", "grieghallen", "Venue", "Main hall, foyer, technical infrastructure and the Summit Dinner", "Offer received", "on"],
];
export const WHO_ASSETS = WHO_DELIVERY.map((d) => d[1]);

export const WhoBehind = ({ nr, mottaker, label = "Who is behind it", testid = "ms-who" }) => (
  <Frame nr={nr} label={label} mottaker={mottaker} className="hd-who hd-light">
    <h2 className="hd-h2" data-testid={`${testid}-h`}>A small team.<br />A serious delivery coalition.</h2>
    <p className="hd-who-sub" data-testid={`${testid}-sub`}>Norwegian AI Summit is initiated and owned by a small team in Bergen — and delivered with a Build Partner and the production, communications and venue partners selected for the standard the room demands. Nothing on this page is presented as signed unless it is.</p>
    <div className="hd-who-team" data-testid={`${testid}-team`}>
      <span className="k">The team · Norwegian AI Summit</span>
      <ul>
        {TEAM.map(([n, , img]) => (
          <li key={n} data-testid={`${testid}-${n.split(" ")[0].toLowerCase()}`}><Img src={img} alt={n} className="ph" draggable={false} /><b>{n}</b><i>{WHO_ROLE[n]}</i></li>
        ))}
      </ul>
    </div>
    <div className="hd-who-del" data-testid={`${testid}-delivered`}>
      <span className="k">Delivered with</span>
      <ul>
        {WHO_DELIVERY.map(([n, logo, cls, t, d, st, on]) => (
          <li key={n} data-testid={`${testid}-${cls}`}><i className={`mask ${cls}`} style={{ "--m": `url(${logo})` }} aria-label={n} /><span className="r"><b>{t}</b>{d}</span><span className={`st ${on}`}>{st}</span></li>
        ))}
      </ul>
    </div>
    <p className="bd-foot hd-who-legend" data-testid={`${testid}-legend`}><b>Agreed in principle</b> — said yes, agreement being formalised · <b>Offer received</b> — written offer, not yet signed · <b>Proposed</b> — in discussion, not yet agreed · Delivery partners are <b>delivered with</b> — never «sponsored by».</p>
  </Frame>
);
